const getAdjacentGoBoardCoordinates = (
  coordinate: GoBoardCoordinate,
  boardSize: number,
): GoBoardCoordinate[] => {
  const candidateCoordinates = [
    { column: coordinate.column - 1, row: coordinate.row },
    { column: coordinate.column + 1, row: coordinate.row },
    { column: coordinate.column, row: coordinate.row - 1 },
    { column: coordinate.column, row: coordinate.row + 1 },
  ];

  return candidateCoordinates.filter(
    (candidateCoordinate) =>
      candidateCoordinate.column >= 0 &&
      candidateCoordinate.column < boardSize &&
      candidateCoordinate.row >= 0 &&
      candidateCoordinate.row < boardSize,
  );
};

export { getAdjacentGoBoardCoordinates };
